export function getSingularAssessmentType(type: string | null | undefined) {
  if (!type) return type
  if (type === 'benchmarks') return 'benchmark'
  if (type === 'formatives') return 'formative'
  if (type === 'assignments') return 'assignment'
  return type
}

export function getPluralAssessmentType(type: string | null | undefined) {
  if (!type) return type
  if (type === 'benchmark') return 'benchmarks'
  if (type === 'formative') return 'formatives'
  if (type === 'assignment') return 'assignments'
  return type
}
